import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import {
  MapPin,
  Phone,
  Mail,
  Clock,
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
} from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    alert("Thank you! We will contact you soon.");

    setFormData({
      name: "",
      email: "",
      phone: "",
      message: "",
    });
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-white">
        <section className="py-24 bg-emerald-900 text-white text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">Contact Us</h1>
          <p className="text-emerald-100 max-w-2xl mx-auto text-lg">
            Have questions about exports, imports, or partnerships? Our team is
            ready to help you.
          </p>
        </section>
        <section className="py-15">
          {/* Grid */}
          <div className="grid lg:grid-cols-2 gap-10">
            {/* Left Side */}
            <div className="space-y-8">
              {/* Contact Info */}
              <Card className="shadow-lg border-none">
                <CardHeader>
                  <CardTitle className="text-2xl">Get In Touch</CardTitle>

                  <CardDescription>
                    Reach us through phone, email, or office visit.
                  </CardDescription>
                </CardHeader>

                <CardContent className="space-y-6">
                  {/* Address */}
                  <div className="flex items-start space-x-4">
                    <div className="bg-emerald-100 p-3 rounded-full">
                      <MapPin className="h-6 w-6 text-emerald-700" />
                    </div>

                    <div>
                      <h4 className="font-semibold text-lg text-gray-900">
                        Office Address
                      </h4>

                      <p className="text-gray-600">
                        Shop No 3, Dharam Weight Bridge, Infront of Nayara
                        Petrol Pump, Walgaon Road, Amravati, Maharashtra, India
                      </p>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="flex items-start space-x-4">
                    <div className="bg-amber-100 p-3 rounded-full">
                      <Phone className="h-6 w-6 text-amber-700" />
                    </div>

                    <div>
                      <h4 className="font-semibold text-lg text-gray-900">
                        Phone
                      </h4>

                      <p className="text-gray-600">+91 76660 68581</p>
                    </div>
                  </div>

                  {/* Email */}
                  {/* <div className="flex items-start space-x-4">
                  <div className="bg-emerald-100 p-3 rounded-full">
                    <Mail className="h-6 w-6 text-emerald-700" />
                  </div>

                  <div>
                    <h4 className="font-semibold text-lg text-gray-900">
                      Email
                    </h4>

                    <p className="text-gray-600">info@yourcompany.com</p>
                  </div>
                </div> */}

                  {/* Timing */}
                  <div className="flex items-start space-x-4">
                    <div className="bg-amber-100 p-3 rounded-full">
                      <Clock className="h-6 w-6 text-amber-700" />
                    </div>

                    <div>
                      <h4 className="font-semibold text-lg text-gray-900">
                        Working Hours
                      </h4>

                      <p className="text-gray-600">
                        Monday - Saturday <br />
                        9:00 AM - 7:00 PM
                      </p>
                    </div>
                  </div>

                  {/* Social Icons */}
                  <div>
                    <h4 className="font-semibold text-lg text-gray-900 mb-4">
                      Follow Us
                    </h4>

                    <div className="flex gap-4">
                      {/* <a
                        href="#"
                        className="w-11 h-11 bg-emerald-100 rounded-full flex items-center justify-center hover:bg-emerald-200 transition"
                      >
                        <Facebook className="h-5 w-5 text-emerald-700" />
                      </a>

                      <a
                        href="#"
                        className="w-11 h-11 bg-emerald-100 rounded-full flex items-center justify-center hover:bg-emerald-200 transition"
                      >
                        <Instagram className="h-5 w-5 text-emerald-700" />
                      </a>

                       <a
                        href="#"
                        className="w-11 h-11 bg-emerald-100 rounded-full flex items-center justify-center hover:bg-emerald-200 transition"
                      >
                        <Twitter className="h-5 w-5 text-emerald-700" />
                      </a> */}

                      <a
                        href="https://www.linkedin.com/in/mohd-uzair-mujiboodin-301687141/"
                        className="w-11 h-11 bg-emerald-100 rounded-full flex items-center justify-center hover:bg-emerald-200 transition"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Linkedin className="h-5 w-5 text-emerald-700" />
                      </a>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Right Side Form */}
            <Card className="shadow-xl border-none">
              <CardHeader>
                <CardTitle className="text-2xl">Send Us A Message</CardTitle>

                <CardDescription>
                  We usually respond within 24 hours.
                </CardDescription>
              </CardHeader>

              <CardContent>
                <form onSubmit={handleSubmit} className="space-y-5">
                  <Input
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        name: e.target.value,
                      })
                    }
                    required
                  />

                  <Input
                    type="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        email: e.target.value,
                      })
                    }
                    required
                  />

                  <Input
                    type="tel"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        phone: e.target.value,
                      })
                    }
                    required
                  />

                  <Textarea
                    rows={6}
                    placeholder="Write your message..."
                    value={formData.message}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        message: e.target.value,
                      })
                    }
                    required
                  />

                  <Button
                    type="submit"
                    className="w-full bg-emerald-700 hover:bg-emerald-800 text-white py-6 text-lg"
                  >
                    Send Message
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;
